import SoftTypography from "components/SoftTypography";

const deletedLabelSx = {
  fontSize: 14,
  color: "error.main",
};

function DeletedLabel({ sx = {pl: "8px"} }) {
  return (
    <SoftTypography sx={{ ...deletedLabelSx, ...sx }} fontWeight="normal">
      Deleted
    </SoftTypography>
  );
}

export default DeletedLabel;
